import { mapGetters, mapState } from "vuex";
import { NAMESPACE } from "../service/editor.constant";
import ROLE from "@configs/role";
import { INTEGRATOR_APP_FEATURE_CATEGORY } from "@modules/app/service/app.constant";
import { isEmpty } from "@utils/var.check";

export default {
  data() {
    return {
      resource: null as Record<string, unknown> | null,
      questionType: "" as string | null,
      uploadFrom: "" as string | null,
      resourceType: "" as string | null,
    };
  },
  computed: {
    ...mapGetters(NAMESPACE.AUTH, ["isTeacher"]),
    ...mapState(NAMESPACE.LESSON, ["lesson"]),
    ...mapState(NAMESPACE.APP, ["integratorAppList"]),
    ...mapGetters(NAMESPACE.APP, [
      "isIntegratorAppEnabled",
      "hasIntegratorAppCategoryAccess",
      "getWhitelistDomainMaps",
    ]),
    hasTtsAccess() {
      return (
        this.isIntegratorAppEnabled(INTEGRATOR_APP_FEATURE_CATEGORY.TTS) &&
        this.hasIntegratorAppCategoryAccess(INTEGRATOR_APP_FEATURE_CATEGORY.TTS)
      );
    },
    hasGoogleDriveAccess() {
      return (
        this.isIntegratorAppEnabled(INTEGRATOR_APP_FEATURE_CATEGORY.GOOGLE_DRIVE) &&
        this.hasIntegratorAppCategoryAccess(INTEGRATOR_APP_FEATURE_CATEGORY.GOOGLE_DRIVE)
      );
    },
    hasAlgebraKitAccess() {
      return (
        this.isIntegratorAppEnabled(INTEGRATOR_APP_FEATURE_CATEGORY.AK) &&
        this.hasIntegratorAppCategoryAccess(INTEGRATOR_APP_FEATURE_CATEGORY.AK)
      );
    },
  },
  provide() {
    const resource = this.resource || {};
    const component = this.component || {};
    const resourceUuid =
      this.resourceType === "LESSON"
        ? this.lesson.uuid
        : resource.uuid && resource.uuid !== "newQuestion"
          ? resource.uuid
          : "";
    const algebraKitSpec = !this.hasAlgebraKitAccess
      ? null
      : this.getAlgebrakitSpec
        ? this.getAlgebrakitSpec()
        : isEmpty(this.question)
          ? null
          : isEmpty(this.question.algebrakitSpec)
            ? null
            : JSON.parse(this.question.algebrakitSpec);
    return {
      pageContext: {
        lessonId: this.lesson.id,
        lessonResourceDomain: this.lesson.resourceDomain,
        lessonStatus: this.lesson ? this.lesson.status : "",
      },
      richTextContext: {
        pageDomain: "editor",
        viewingRole: this.isTeacher ? ROLE.TEACHER : "",
        pageId: component.pageId || "",
        componentId: component.componentId || "",
        uploadFrom: this.uploadFrom || "",
        resourceUuid: resourceUuid,
        resourceType: this.resourceType, // backend: ResourceContextType possible values: LESSON, QUIZ, QUESTION
        hasTtsAccess: this.hasTtsAccess,
        hasGoogleDriveAccess: this.hasGoogleDriveAccess,
        lessonId: this.lesson.id,
        lessonUuid: this.lesson.uuid,
        lessonTitle: this.lesson.title,
        whitelistDomainMaps: this.getWhitelistDomainMaps,
        resourceDomain: this.lesson.resourceDomain,
        ownerGroupId: this.lesson.ownerGroupId,
        isScorable: this.questionType === "FREE",
        algebrakitSpec: algebraKitSpec,
        algebrakitRefId: !this.hasAlgebraKitAccess
          ? null
          : this.question
            ? this.question.algebrakitRefId
            : null,
        isQuestion: isDefined(this.question),
        assignmentUuid: this.lesson.lessonAssignmentUuid,
        lessonAssignmentUuid: this.lesson.lessonAssignmentUuid,
      },
    };
  },
};
